(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-protection-glass"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-protection-glass')) {
    class FreeProtectionGlass extends HTMLElement {
      async connectedCallback() {
        this.button = this.querySelector('[data-free-protection-glass-button]');
        this.buttonLabel = this.querySelector('[data-free-protection-glass-button-label]');
        this.status = this.querySelector('[data-free-protection-glass-status]');
        this.variants = this.#readVariants();
        this.addedVariantId = null;
        this.isAdding = false;

        this.button?.addEventListener('click', this.#handleClick.bind(this));
        document.addEventListener('variantChange', this.#handleVariantChange.bind(this));
        document.addEventListener('variant:change', this.#handleVariantChange.bind(this));
        document.addEventListener('cart:updated', this.#handleCartUpdated.bind(this));

        await this.#syncAddedVariantFromCart();
        this.#updateAvailability();
      }

      async #handleCartUpdated() {
        await this.#syncAddedVariantFromCart();
        this.#updateAvailability();
      }

      async #syncAddedVariantFromCart() {
        const glassVariantIds = new Set(this.variants.map((variant) => String(variant.id)));
        if (glassVariantIds.size === 0) return;

        try {
          const response = await fetch(this.dataset.cartUrl);
          if (!response.ok) return;

          const cart = await response.json();
          const matchingItem = cart.items.find((item) => glassVariantIds.has(String(item.variant_id)));
          this.addedVariantId = matchingItem ? matchingItem.variant_id : null;
        } catch (error) {
          console.error('Free protection glass: cart could not be read.', error);
        }
      }

      #readVariants() {
        const variantData = this.querySelector('[data-free-protection-glass-variants]');
        if (!variantData) return [];

        try {
          return JSON.parse(variantData.textContent);
        } catch (error) {
          console.error('Free protection glass: variants could not be read.', error);
          return [];
        }
      }

      #getSelectedCaseVariant() {
        const section = document.getElementById(`ProductSection-${this.dataset.sectionId}-${this.dataset.productId}`);
        const selectedId = section?.querySelector('[data-product-select]')?.value;
        const variantData = section?.querySelector('[data-variant-json]');
        if (!selectedId || !variantData) return null;

        try {
          const variants = JSON.parse(variantData.value || variantData.textContent);
          return variants.find((variant) => String(variant.id) === String(selectedId)) || null;
        } catch (error) {
          console.error('Free protection glass: selected case variant could not be read.', error);
          return null;
        }
      }

      #getCompatibleGlassVariant(caseVariant) {
        const resolvedCaseVariant = caseVariant !== undefined ? caseVariant : this.#getSelectedCaseVariant();
        const model = resolvedCaseVariant
          ? resolvedCaseVariant[`option${this.dataset.modelOptionPosition}`]
          : this.dataset.initialModel;

        return this.variants.find((variant) => variant.model === model && variant.available) || null;
      }

      #handleVariantChange(event) {
        this.#updateAvailability(event?.detail?.variant);
      }

      #updateAvailability(caseVariant) {
        const compatibleVariant = this.#getCompatibleGlassVariant(caseVariant);

        if (!compatibleVariant) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        this.#applyState(compatibleVariant);
      }

      #applyState(compatibleVariant) {
        const isAddedForThisModel = this.addedVariantId === compatibleVariant.id;
        const hasDifferentGlassAdded = this.addedVariantId !== null && !isAddedForThisModel;

        this.classList.toggle('free-protection-glass--added', isAddedForThisModel);
        this.classList.toggle('free-protection-glass--swap', hasDifferentGlassAdded);

        if (isAddedForThisModel) {
          this.buttonLabel.textContent = `✓ ${this.dataset.addedLabel}`;
        } else if (hasDifferentGlassAdded) {
          this.buttonLabel.textContent = this.dataset.exchangeLabel;
        } else {
          this.buttonLabel.textContent = this.dataset.addLabel;
        }
      }

      async #handleClick() {
        if (this.isAdding) return;

        const glassVariant = this.#getCompatibleGlassVariant();
        if (!glassVariant || glassVariant.id === this.addedVariantId) {
          this.#updateAvailability();
          return;
        }

        this.isAdding = true;
        this.button?.setAttribute('aria-busy', 'true');
        const previousVariantId = this.addedVariantId;

        try {
          if (previousVariantId) {
            const removeResponse = await fetch(this.dataset.cartChangeUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ id: String(previousVariantId), quantity: 0 })
            });

            if (!removeResponse.ok) throw new Error(`HTTP ${removeResponse.status}`);
            this.addedVariantId = null;
          }

          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: glassVariant.id, quantity: 1 })
          });

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          this.addedVariantId = glassVariant.id;
          this.#applyState(glassVariant);
          this.status.textContent = this.buttonLabel.textContent;

          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (error) {
          console.error('Free protection glass could not be added to cart.', error);
          this.status.textContent = this.dataset.errorLabel;
          this.#updateAvailability();
        } finally {
          this.isAdding = false;
          this.button?.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('free-protection-glass', FreeProtectionGlass);
  }
  } catch(e) { console.error(e); }
})();

})();
